module.exports = __webpack_public_path__ + "static/media/tannico-512.e1d9e3f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tannico-512.png
// module id = 785
// module chunks = 0